<template>
  <div>
    <table width="100%">
      <thead
        class="t-head"
        :style="{ borderTop: borderTop ? 'solid 1px #e5e7eb' : 'none' }"
      >
        <tr>
          <td v-for="item in headers" :key="item.value">
            <span style="display: flex" v-if="item.orderable">
              <span
                style="cursor: pointer"
                @click="changeOrder(item.value)"
                :style="{
                  fontWeight: item.value == orderColumn ? 'bold' : '100',
                }"
              >
                {{ item.text }}
              </span>
              <span class="t-head-order" @click="changeOrder(item.value)">
                <span
                  class="t-head-order-asc"
                  style="cursor: pointer"
                  :style="{
                    borderBottom:
                      item.value == orderColumn
                        ? styleAscOrder
                        : styleNonActive,
                  }"
                />
                <span
                  class="t-head-order-desc"
                  style="cursor: pointer"
                  :style="{
                    borderTop:
                      item.value == orderColumn
                        ? styleDescOrder
                        : styleNonActive,
                  }"
                />
              </span>
            </span>
            <span v-else>
              {{ item.text }}
            </span>
          </td>
        </tr>
      </thead>
      <tbody v-show="!loading">
        <!-- style="cursor: pointer" -->
        <tr v-if="items.length == 0">
          <td :colspan="headers.length" style="text-align: center">
            No results found
          </td>
        </tr>
        <tr v-for="item in items" :key="item.id" class="t-row" v-else>
          <td
            v-for="header in headers"
            :key="header.value"
            :width="header.width ? header.width : '10%'"
            @click="checkClicked(header, $event, item)"
            :style="{ cursor: header.clicked ? 'pointer' : 'default' }"
          >
            <span v-if="!header.sloted">
              <!-- if header nested -->
              {{ fetchHeader(header, item) }}
              <!-- {{ item[header.value] }} -->
            </span>
            <slot :name="header.value" v-bind="{ item, header }" />
          </td>
        </tr>
      </tbody>
      <tbody v-show="loading">
        <tr v-for="item in items" :key="item.id">
          <td
            v-for="header in headers"
            :key="header.value"
            :width="header.width ? header.width : '10%'"
          >
            <AdminLineLoader />
          </td>
        </tr>
      </tbody>
    </table>
    <AdminDatatablePagination
      :lastPage="lastPage"
      :totalPage="totalPage"
      :totalItems="totalItems"
      :itemFrom="itemFrom"
      :itemTo="itemTo"
      :currentPage="currentPage"
      :links="paginationLinks"
      :perPage="perPage"
      @mutateCurrentPage="mutateCurrentPage($event)"
      @mutatePerPage="mutatePerPage($event)"
    />
  </div>
</template>

<script>
import AdminDatatablePagination from "./AdminDatatablePagination.vue";
import AdminLineLoader from "../AdminLineLoader.vue";
export default {
  components: {
    AdminDatatablePagination,
    AdminLineLoader,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: () => {
        return null;
      },
    },
    // perPage: {
    //   type: Number,
    //   default: () => {
    //     return 10;
    //   },
    // },
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filter: {
      type: Object,
      default: () => {
        return {
          search: null,
        };
      },
    },
  },
  data() {
    return {
      perPage: 10,
      itemFrom: null,
      itemTo: null,
      loading: false,
      items: [],
      currentPage: 1,
      totalItems: null,
      totalPage: null,
      paginationLinks: [],
      asc: false,
      orderColumn: null,
      lastPage: null,
    };
  },
  mounted() {
    this.movePage(1);
  },
  methods: {
    movePage(page) {
      this.loading = true;
      let inputs = {};
      inputs.method = "get";
      inputs.url = this.url;
      inputs.page = page;
      inputs.length = this.perPage;
      inputs.dir = this.asc ? "asc" : "desc";
      inputs.column = this.orderColumn;
      inputs.search = this.filter.search;
      inputs.filter = this.filter;

      this.$store.dispatch("API", inputs).then((result) => {
        this.items = result.data;
        // this.totalItems = result.meta.total;
        this.totalPage = result.meta.last_page;
        this.currentPage = result.meta.current_page;
        // this.paginationLinks = result.links;
        this.itemFrom = result.meta.from;
        this.itemTo = result.meta.to;
        this.loading = false;
        this.lastPage = result.meta.last_page;

        //
      });
    },
    mutateCurrentPage(value) {
      this.currentPage = this.movePage(value);
    },
    mutatePerPage(value) {
      this.perPage = parseInt(value);
      this.movePage(this.currentPage);
    },
    fetchHeader(header, item) {
      if (header.value.includes(".")) {
        const arrayHeader = header.value.split(".");
        let value = null;
        for (let i = 0; i < arrayHeader.length; i++) {
          const element = arrayHeader[i];
          if (value) value = value[element];
          else value = item[element];
        }

        return value ?? "-";
      } else {
        return item[header.value] ?? "-";
      }
    },
    changeOrder(key) {
      //
      if (key == this.orderColumn) {
        this.asc = !this.asc;
      } else {
        this.asc = "asc";
      }
      this.orderColumn = key;

      this.movePage(this.currentPage);
    },
    checkClicked(header, event, item) {
      if (header.clicked) this.$emit("detail", item);
    },
  },
  computed: {
    styleAscOrder() {
      return this.asc ? "6px solid #a3a3a3" : "6px solid #cccccc";
    },
    styleDescOrder() {
      return !this.asc ? "6px solid #a3a3a3" : "6px solid #cccccc";
    },
    styleNonActive() {
      return "6px solid #cccccc";
    },
  },
  watch: {
    search() {
      this.movePage(this.currentPage);
    },
    filter: {
      handler(value) {
        this.movePage(1);
      },
      deep: true,
    },
  },
};
</script>


<style lang="css" scoped>
table {
  color: #6b7280;
}

.t-row {
  height: 54px;
  padding-bottom: 10px;
  cursor: pointer;
}

.t-head {
  /* text-transform: uppercase; */
  border-bottom: solid 1px #e5e7eb;
  border-top: solid 1px #e5e7eb;
  background-color: rgba(220, 220, 220, 1);
}

th {
  padding: 16px;
}

td {
  padding: 16px;
}

.t-row:nth-child(even) {
  background: rgba(248, 248, 248, 1);
}
.t-row:nth-child(odd) {
  background: rgba(234, 234, 234, 1);
}

.chip-status {
  padding: 2px 10px 2px 10px;
  border-radius: 10px;
}
.t-head-order {
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.t-head-order-asc {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  margin-bottom: 2px;
}

.t-head-order-desc {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}
</style>
